import { render, staticRenderFns } from "./Expedition.vue?vue&type=template&id=78a63a17&scoped=true&"
import script from "./Expedition.vue?vue&type=script&lang=js&"
export * from "./Expedition.vue?vue&type=script&lang=js&"
import style0 from "./HistoryRetur.scss?vue&type=style&index=0&id=78a63a17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a63a17",
  null
  
)

export default component.exports